import { defineMessages } from 'react-intl';

export const types = defineMessages({
    speeding: {
        id: 'alert.type.speeding',
        defaultMessage: 'Speeding'
    },
    zoneConflict: {
        id: 'alert.type.speeding',
        defaultMessage: 'Crossing of {zone}'
    }
});